import { REACT_APP_GLOBAL_API_BASE_URL_V2 } from 'runtimeEnvVars';

import { apiGet } from '../utils/axios';

export const fetchStages = jobId => {
  const url = `${REACT_APP_GLOBAL_API_BASE_URL_V2}/jobs/${jobId}/stages`;
  return apiGet(url);
};
